module.exports = __webpack_public_path__ + "img/10Life-Trending.d0726dd.png";